$('.hero-banner').slick({
dots: false,
arrows: false,
slidesToShow: 1,
slidesToScroll: 1,
prevArrow:
'<img class="slick-arrow slick-prev" src="https://cdn.shopify.com/s/files/1/0947/5804/4030/files/Rectangle_119_1.png?v=1756458166">',
nextArrow:
'<img class="slick-arrow slick-next" src="https://cdn.shopify.com/s/files/1/0947/5804/4030/files/Rectangle_119_2.png?v=1756458158">',
infinite: true,
responsive: [
{
breakpoint: 1441,
settings: {
slidesToShow: 1,
dots: false,
},
},
{
breakpoint: 1200,
settings: {
slidesToShow: 1,
dots: true,
},
},
{
breakpoint: 990,
settings: {
slidesToShow: 1,
dots: true,
},
},
{
breakpoint: 750,
settings: {
slidesToShow: 1,
dots: true,
arrows: false,
},
},
{
breakpoint: 550,
settings: {
slidesToShow: 1,
dots: true,
arrows: false,
},
},
],
});



$('.main-wrapper').slick({
dots: false,
arrows: false,
slidesToShow: 3,
slidesToScroll: 1,
prevArrow:
'<img class="slick-arrow slick-prev" src="https://cdn.shopify.com/s/files/1/0947/5804/4030/files/Rectangle_119_1.png?v=1756458166">',
nextArrow:
'<img class="slick-arrow slick-next" src="https://cdn.shopify.com/s/files/1/0947/5804/4030/files/Rectangle_119_2.png?v=1756458158">',
infinite: true,
responsive: [
{
breakpoint: 1441,
settings: {
slidesToShow: 3,
dots: false,
},
},
{
breakpoint: 1200,
settings: {
slidesToShow: 2,
dots: true,
},
},
{
breakpoint: 990,
settings: {
slidesToShow: 2,
dots: true,
},
},
{
breakpoint: 750,
settings: {
slidesToShow: 2,
dots: true,
arrows: false,
},
},
{
breakpoint: 550,
settings: {
slidesToShow: 1,
dots: true,
arrows: false,
},
},
],
});


$('.review-text').slick({
  dots: false,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow:
    '<svg class="slick-arrow slick-prev" width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.5 16L1 8.5L8.5 1" stroke="#262626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  nextArrow:
    '<svg class="slick-arrow slick-next" width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L8.5 8.5L1 16" stroke="#262626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  infinite: true,
  responsive: [
    {
      breakpoint: 1441,
      settings: {
        slidesToShow: 1,
        arrows: true,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 1,
        arrows: true,
      },
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: false,
      },
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: false,
      },
    },
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: false,
      },
    },
  ],
});



$(document).ready(function() {
  // Initialize slick only if the window width is 990px or more
  function initializeSlider() {
    if ($(window).width() <= 990) {
      console.log("hello");
        $('.custom-featured-collection .block-wrapper').slick({
          dots: false,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow:
            '<svg class="slick-arrow slick-prev" width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.5 16L1 8.5L8.5 1" stroke="#262626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
          nextArrow:
            '<svg class="slick-arrow slick-next" width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L8.5 8.5L1 16" stroke="#262626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
          infinite: true,
          responsive: [
            {
              breakpoint: 1441,
              settings: {
                slidesToShow: 1,
                arrows: false,
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 1,
                arrows: false,
              },
            },
            {
              breakpoint: 990,
              settings: {
                slidesToShow: 2,
                dots: true,
                arrows: false,
              },
            },
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 2,
                dots: true,
                arrows: false,
              },
            },
            {
              breakpoint: 550,
              settings: {
                slidesToShow: 1,
                dots: true,
                arrows: false,
              },
            },
          ],
        });
      
    }
  }

  // Call the initializeSlider function on document ready
  initializeSlider();


  // Reinitialize the slider when the window is resized
  $(window).resize(function() {
    initializeSlider();
  });
});


$(document).ready(function() {
  // Initialize slick only if the window width is 990px or more
  function initializeSlider() {
    if ($(window).width() <= 990) {
      console.log("hello");
        $('custom-related').slick({
          dots: false,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow:
            '<svg class="slick-arrow slick-prev" width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.5 16L1 8.5L8.5 1" stroke="#262626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
          nextArrow:
            '<svg class="slick-arrow slick-next" width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L8.5 8.5L1 16" stroke="#262626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
          infinite: true,
          responsive: [
            {
              breakpoint: 1441,
              settings: {
                slidesToShow: 1,
                arrows: false,
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 1,
                arrows: false,
              },
            },
            {
              breakpoint: 990,
              settings: {
                slidesToShow: 3,
                dots: true,
                arrows: false,
              },
            },
            {
              breakpoint: 850,
              settings: {
                slidesToShow: 2,
                dots: true,
                arrows: false,
              },
            },
            {
              breakpoint: 550,
              settings: {
                slidesToShow: 1,
                dots: true,
                arrows: false,
              },
            },
          ],
        });
      
    }
  }

  // Call the initializeSlider function on document ready
  initializeSlider();


  // Reinitialize the slider when the window is resized
  $(window).resize(function() {
    initializeSlider();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.faq-header').forEach(header => {
    header.addEventListener('click', function () {
      const container = this.closest('.main-image-text-container');

      document.querySelectorAll('.main-image-text-container').forEach(item => {
        if (item !== container) item.classList.remove('active');
      });

      container.classList.toggle('active');
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const regularEl = document.querySelector(
    '.price__sale s.price-item--regular'
  );
  const saleEl = document.querySelector(
    '.price-item--sale'
  );
  const discountEl = document.querySelector(
    '.custom-price-discount'
  );

  console.log('[PRICE] Regular element:', regularEl);
  console.log('[PRICE] Sale element:', saleEl);

  if (!regularEl || !saleEl || !discountEl) {
    console.warn('[PRICE] Required elements not found');
    return;
  }

  const regularText = regularEl.innerText.trim();
  const saleText = saleEl.innerText.trim();

  console.log('[PRICE] Regular text:', regularText);
  console.log('[PRICE] Sale text:', saleText);

  // Convert "1.279,99 DKK" → 127999
  const regularPrice = parseInt(regularText.replace(/\D/g, ''), 10);
  const salePrice = parseInt(saleText.replace(/\D/g, ''), 10);

  console.log('[PRICE] Regular number:', regularPrice);
  console.log('[PRICE] Sale number:', salePrice);

  if (!regularPrice || !salePrice || salePrice >= regularPrice) {
    console.warn('[PRICE] No valid discount');
    discountEl.innerText = '';
    return;
  }

  const discountPercent = Math.round(
    ((regularPrice - salePrice) / regularPrice) * 100
  );

  discountEl.innerText = `${discountPercent}% off`;

  console.log('[PRICE] Discount applied:', discountPercent + '%');
});
